import { render, staticRenderFns } from "./SpecialBasic.vue?vue&type=template&id=7d10f412&scoped=true&"
import script from "./SpecialBasic.vue?vue&type=script&lang=js&"
export * from "./SpecialBasic.vue?vue&type=script&lang=js&"
import style0 from "./SpecialBasic.vue?vue&type=style&index=0&id=7d10f412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d10f412",
  null
  
)

export default component.exports